<template>
  <v-dialog max-width="600px" persistent v-model="modalPaymentMethod.dialog">
    <v-card>
      <div class="d-flex">
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="hidePaymentMethodDialog"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-card-title class="text-h6 text-md-h4 lighten-2">Payment method required.</v-card-title>
      <v-card-text class="mt-3">
        <p>Hi there!</p>
        <p>We're happy to have you with us. Unfortunately, there is only one more step to do before you can purchase tokens. You need to set up a default payment method and come back here.</p>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn 
          exact
          @click="addPayment"
          color="primary"
        >
          Add Payment Method
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["modalPaymentMethod"])
  },
  methods: {
   hidePaymentMethodDialog() {
     this.$store.dispatch("hidePaymentMethodDialog")
   },
   addPayment() {
    this.$store.dispatch("hidePaymentMethodDialog");
    this.$router.push({name: 'payment-methods-add', query: {continue: this.$route.fullPath}});
   }
  }
}
</script>